import React, { Component } from 'react';
import {
    Text,
    BlockStack,
    Badge,
    Button,
    Pagination,
    Spinner,
    Card,
    Tabs,

} from '@shopify/polaris';
import '../index.scss';
import Language from '../../../../../i18n/Language';
import TableFilters from '../../../../../components/TableFilters';
import IndexTableImage from './IndexTableImage';
import FooterPageSelect from '../../../../../components/FooterPageSelect/indexPage';
import { ArrowRightIcon } from "@shopify/polaris-icons";

const t = Language;
class ManaullyModal extends Component {
    state = {
        isShowManuallyModal: this.props.isShowManuallyModal,    // 弹窗状态
        Headings: [
            { title: '' },
            { title: t("Title") },
            { title: t("Status") },
            { title: t("Action") },
        ],                                                      // 表格标题
        proHeadings: [
            { title: '' },
            { title: t("Product Title") },
            { title: t("Total Images") },
            { title: t("Status") },
            { title: t("Action") },
        ],
        tableRes: this.props.tableRes,                          // 分页及列表
        tableData: this.props.tableData,                        // 表格列表
        mCheckState: false,                                     // 是否开启选择
        queryValue: this.props.queryValue,                      // 搜索内容
        tabKey: this.props.tabKey,                              // 标题id
        tableLoading: this.props.tableLoading,                  // 手动表格loading
        page: this.props.page,
        pageSize: this.props.pageSize,
        manuallyPre: this.props.manuallyPre,                     // 上页
        manuallyNext: this.props.manuallyNext,                   // 下页
        isShowImgCompression: this.props.isShowImgCompression,
        isShowImgAltText: this.props.isShowImgAltText,
        isShowImgFilename: this.props.isShowImgFilename,
        ConvertImg: this.props.ConvertImg,
        AddWaterImg: this.props.AddWaterImg,
        is_default: this.props.is_default,                       // 是否第一次设置
        image_opt: this.props.image_opt,                        // 初始设置数据
        alt_text: this.props.alt_text,                          // 初始设置数据
        file_name: this.props.file_name,                        // 初始设置数据
        isImageCompression: this.props.isImageCompression,                              // 开启状态
        isConvertImage: this.props.isConvertImage,
        isAddWatermark: this.props.isAddWatermark,
        isImageAlttext: this.props.isImageAlttext,
        isImageFilename: this.props.isImageFilename,
        isShowAutoState: this.props.isShowAutoState,
        isShowProgress: this.props.isShowProgress,
        opt_status: this.props.opt_status,
        shopify_status: this.props.shopify_status,
        isShowFileOpt: this.props.isShowFileOpt,
        tabMode: 'FILTERING',
    }

    componentDidMount() {

    }

    shouldComponentUpdate(nextProps) {
        if (nextProps.isShowManuallyModal !== this.props.isShowManuallyModal) {
            this.setState({
                isShowManuallyModal: nextProps.isShowManuallyModal,
                is_default: nextProps.is_default,
            })
        }
        if (nextProps.tabKey !== this.props.tabKey) {
            this.setState({
                tabKey: nextProps.tabKey,
            })
        }
        if (nextProps.tableData !== this.props.tableData) {
            this.setState({
                tableData: nextProps.tableData,
                tableRes: nextProps.tableRes,
            })
        }
        if (nextProps.tableLoading !== this.props.tableLoading) {
            this.setState({
                tableLoading: nextProps.tableLoading,
            })
        }
        if (nextProps.queryValue !== this.props.queryValue) {
            this.setState({
                queryValue: nextProps.queryValue,
            })
        }
        if (nextProps.image_opt !== this.props.image_opt) {
            this.setState({
                image_opt: nextProps.image_opt,
                alt_text: nextProps.alt_text,
                file_name: nextProps.file_name,
            })
        }
        if (nextProps.isImageCompression !== this.props.isImageCompression) {
            this.setState({
                isImageCompression: nextProps.isImageCompression,
            })
        }
        if (nextProps.isConvertImage !== this.props.isConvertImage) {
            this.setState({
                isConvertImage: nextProps.isConvertImage,
            })
        }
        if (nextProps.isAddWatermark !== this.props.isAddWatermark) {
            this.setState({
                isAddWatermark: nextProps.isAddWatermark,
            })
        }
        if (nextProps.isImageAlttext !== this.props.isImageAlttext) {
            this.setState({
                isImageAlttext: nextProps.isImageAlttext,
            })
        }
        if (nextProps.isImageFilename !== this.props.isImageFilename) {
            this.setState({
                isImageFilename: nextProps.isImageFilename,
            })
        }
        if (nextProps.manuallyPre !== this.props.manuallyPre) {
            this.setState({
                manuallyPre: nextProps.manuallyPre,
            })
        }
        if (nextProps.manuallyNext !== this.props.manuallyNext) {
            this.setState({
                manuallyNext: nextProps.manuallyNext,
            })
        }
        if (nextProps.page !== this.props.page) {
            this.setState({
                page: nextProps.page,
            })
        }
        if (nextProps.isShowAutoState !== this.props.isShowAutoState) {
            this.setState({
                isShowAutoState: nextProps.isShowAutoState,
            })
        }
        if (nextProps.isShowProgress !== this.props.isShowProgress) {
            this.setState({
                isShowProgress: nextProps.isShowProgress,
            })
        }
        if (nextProps.opt_status !== this.props.opt_status) {
            this.setState({
                opt_status: nextProps.opt_status,
            })
        }
        if (nextProps.shopify_status !== this.props.shopify_status) {
            this.setState({
                shopify_status: nextProps.shopify_status,
            })
        }
        return true;
    }

    // 打开设置
    openSetupBoxBack = () => {
        this.props.openSetupBox();
    }

    // 关闭弹窗
    handleStateChangeBack = (name, val) => {
        this.props.handleStateChange(name, val);
    }

    // 切换tab
    handleTypeTabsChange = (e) => {
        this.props.changeManuallyTab(e);
    }

    // 搜索
    setQueryValue = (val) => {
        this.props.changeManuallyQueryVal(val);
    }

    // 获取批量数据
    getTableItemState = (data) => {
        this.setState({
            tableItemState: data
        }, () => {
            this.props.setManuallyTableItemData(data)
        })
    }

    // 开始批量
    OptimizeNowManaully = () => {
        this.props.handleOptManaully();
    }

    // 分页
    changeManuallyPage = (e) => {
        this.props.changeManuallyPageData(e);
    }

    // 改变页面条数
    changePageSizeData = (s) => {
        this.props.changeManuallyPageSizeData(s);
    }

    // 设置搜索模式
    handleSetMode = (mode) => {
        this.setState({
            tabMode: mode,
        })
    }

    render() {
        const {
            Headings,
            proHeadings,
            tableData,
            mCheckState,
            queryValue,
            tabKey,
            tableLoading,
            tableRes,
            page,
            manuallyPre,
            manuallyNext,
            is_default,
            isImageCompression,
            // isConvertImage,
            isAddWatermark,
            isImageAlttext,
            isImageFilename,
            isShowAutoState,
            isShowProgress,
            opt_status,
            shopify_status,
            isShowFileOpt,
            tabMode,

        } = this.state;

        // 表格标题
        const tabHeadings = tabKey === 0 ? proHeadings : [
            { title: '' },
            { title: tabKey === 1 ? t("Collection Title") : tabKey === 2 ? t("Blog Title") : t("Title") },
            { title: t("Status") },
            { title: t("Action") },
        ];

        // 分页
        const footerContentText = <FooterPageSelect
            custom_type={tabKey === 0 ? t("products") : tabKey === 1 ? t("collections") : t("blogs")}
            page={tableRes.current_page}
            current_PageSize={tableRes.per_page}
            total={tableRes.total}
            changePageSize={this.changePageSizeData}
            handlePageBlur={this.props.handlePageBlur}
            tableLoading={tableLoading}
        />

        // 手动弹窗
        const manuallySetModal = <div className='manually_set_modal'>
            {
                Boolean(isShowAutoState) && <div className='manually_set_shade'></div>
            }
            <BlockStack gap={400}>
                <div className='manually_set_tip modal_set_tip'>
                    <Text variant="headingMd" as="h2">{t("Manual Optimize Images")}</Text>
                    <Text as="p">
                        {t("Select and optimize existing images manually base on your")}
                        &nbsp;
                        <Button onClick={this.openSetupBoxBack} variant='plain' textAlign="left">{t("settings")}.</Button>
                        &nbsp;
                        {t("You can restore them within {{v1}} days in Optimization History.", 30)}
                    </Text>
                </div>
                <div className='manually_func_state flex_layout'>
                    <div className='m_set_item'>
                        <span className='flex_layout'>
                            <Text variant='headingMd' as="h2">{t("Image Compression")}</Text> <Badge tone={isImageCompression ? 'success' : ''}>{isImageCompression ? t("On") : t("Off")}</Badge>
                        </span>
                        <Button variant='tertiary' icon={ArrowRightIcon} onClick={this.openSetupBoxBack}></Button>
                    </div>
                    <div className='m_set_item'>
                        <span className='flex_layout'>
                            <Text variant='headingMd' as="h2">{t("Add Image Watermarks")}</Text> <Badge tone={isAddWatermark ? 'success' : ''}>{isAddWatermark ? t("On") : t("Off")}</Badge>
                        </span>
                        <Button variant='tertiary' icon={ArrowRightIcon} onClick={this.openSetupBoxBack}></Button>
                    </div>
                    {
                        Boolean(isShowFileOpt) && <div className='m_set_item'>
                            <span className='flex_layout'>
                                <Text variant='headingMd' as="h2">{t("Optimize Image Filename")}</Text> <Badge tone={isImageFilename ? 'success' : ''}>{isImageFilename ? t("On") : t("Off")}</Badge>
                            </span>
                            <Button variant='tertiary' icon={ArrowRightIcon} onClick={this.openSetupBoxBack}></Button>
                        </div>
                    }
                </div>
                <div className='manual_table_collect'>
                    <Card padding={0}>
                        <div className={`fake_tabs ${(tabMode === 'FILTERING') ? 'active' : ''}`}>
                            <Tabs tabs={[
                                { id: 1, content: t("Product") },
                                { id: 2, content: t("Collection") },
                                { id: 3, content: t("Blog") },
                            ]} selected={tabKey} onSelect={(e) => this.handleTypeTabsChange(e)}></Tabs>
                        </div>
                        <TableFilters
                            loading={tableLoading}
                            itemStrings={[
                                t("Product"),
                                t("Collection"),
                                t("Blog"),
                            ]}
                            pageFilter='ManuallyImgOpt'
                            queryValue={queryValue}
                            typeSelected={tabKey}
                            opt_status={opt_status}
                            shopify_status={shopify_status}
                            isShowFilters={true}
                            searchMode={'FILTERING'}
                            optStatusListData={[
                                {
                                    value: 1,
                                    label: t("Optimized"),
                                },
                                {
                                    value: 2,
                                    label: t("Unoptimized"),
                                }
                            ]}
                            productStatusListData={tabKey === 0 ? [
                                {
                                    value: 'ACTIVE',
                                    label: t("ACTIVE"),
                                },
                                {
                                    value: 'ARCHIVED',
                                    label: t("ARCHIVED"),
                                },
                                {
                                    value: 'DRAFT',
                                    label: t("DRAFT"),
                                },
                                {
                                    value: 'UNLISTED',
                                    label: t("UNLISTED"),
                                }
                            ] : []}
                            setSelectedTabsIndex={(e) => this.handleTypeTabsChange(e)}
                            setQueryValue={(v) => this.setQueryValue(v)}
                            setOptStatusChange={this.props.setOptStatusChange}
                            setProductStatusChange={this.props.setProductStatusChange}
                            handleSetMode={this.handleSetMode}
                        />
                        <div className={`${tableData.length >= 5 && 'manually_table_list'}`}>
                            {
                                (is_default === 1 || (!Boolean(isImageCompression) && !Boolean(isAddWatermark) && !Boolean(isImageAlttext) && !Boolean(isImageFilename))) ? <div className='manually_empty'>
                                    <BlockStack gap={400} inlineAlign="center">
                                        <Text variant="headingLg" as="h2">
                                            {t("No optimization setting for")}
                                            &nbsp;{tabKey === 0 ? t("product") : tabKey === 1 ? t("collection") : t("blog")}&nbsp;
                                            {t("images")}.
                                        </Text>
                                        <Text as="p" color="subdued">
                                            {t("You should first set up the settings for optimizing")}
                                            &nbsp;{tabKey === 0 ? t("product") : tabKey === 1 ? t("collection") : t("blog")}&nbsp;
                                            {t("images")}.
                                        </Text>
                                        <div><Button variant="primary" onClick={this.openSetupBoxBack}>{t("Go to set up")}</Button></div>
                                    </BlockStack>
                                </div> : <IndexTableImage
                                    id={`Manually_Table_${tabKey}`}
                                    loading={tableLoading}
                                    tabKey={tabKey}
                                    headings={tabHeadings}
                                    dataList={(isShowAutoState) ? [] : tableData}
                                    checkState={mCheckState}
                                    total={tableRes.total}
                                    obj_name={tabKey === 0 ? 'products' : tabKey === 1 ? 'collections' : 'blogs'}
                                    getTableItemState={this.getTableItemState}
                                    promotedBulkActions={[
                                        {
                                            content: t("Optimize now"),
                                            onAction: this.OptimizeNowManaully,
                                            disabled: isShowProgress !== -1,
                                        },
                                    ]}
                                    tableType={'manually'}
                                    isShowProgress={isShowProgress}
                                    handleOptimize={this.props.handleOptimize}
                                />
                            }
                        </div>
                        {
                            (is_default === 1 || (!Boolean(isImageCompression) && !Boolean(isAddWatermark) && !Boolean(isImageAlttext) && !Boolean(isImageFilename)) || isShowAutoState) ? null :
                                (tableData.length > 0 && <div className='justify_center sticky_footer'>
                                    <Pagination
                                        label={footerContentText}
                                        hasPrevious={manuallyPre && !tableLoading}
                                        onPrevious={() => this.changeManuallyPage(page - 1)}
                                        hasNext={manuallyNext && !tableLoading}
                                        onNext={() => this.changeManuallyPage(page + 1)}
                                    />
                                </div>)
                        }
                    </Card>
                </div>
            </BlockStack>
        </div>
        // <Modal
        //     size='large'
        //     open={isShowManuallyModal}
        //     onClose={() => this.handleStateChangeBack('isShowManuallyModal', false)}
        //     title={t("Manually optimization")}
        // >
        //  {slot}
        // </Modal>

        return manuallySetModal;
    }
}

export default ManaullyModal;

